import {withRouter} from 'react-router';

import DefaultForm from '@appComponents/DefaultForm';

export class PropertyLicencePricingForm extends DefaultForm {
    prepareDataForSubmit = (data) => ({
        ...this.props.Model.dataMap[this.props.Model.entityDataMapKey],
        ...data,
    });

    renderDeleteButton = () => null;

    renderCancelButton = () => null;
}

export default withRouter(PropertyLicencePricingForm);
